import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cinema__slides-error-wrapper"
}

import { useCinemaStore } from '@remote/store/cinema'
// import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import AndroidPullToRefresh from '@remote/components/interaction/AnPullToRefresh.vue'
import CinemaSlideIndex from '@remote/components/cinema/CinemaSlideIndex.vue'
import CinemaSlideMovie from '@remote/components/cinema/CinemaSlideMovie.vue'
import CinemaSlideTVSeries from '@remote/components/cinema/CinemaSlideTVSeries.vue'
import CinemaSlideOther from '@remote/components/cinema/CinemaSlideOther.vue'
import CinemaHeader from '@remote/components/cinema/CinemaHeader.vue'
import CinemaRefreshBar from '@remote/components/cinema/CinemaRefreshBar.vue'
import 'swiper/swiper.min.css'
import { 
  ref, 
  // onMounted, 
  watch, computed, 
  // ComponentPublicInstance 
} from 'vue'
// import { openCinemaSourceSetting } from '@remote/utils/dialog'
// import { getNFODirs } from '@remote/api/nfo'
// import { useBaseStore } from '@remote/store/base'
import { checkState } from '@remote/store/utils'
// import { MINUTE } from '@shared/constants/time'
import { stat } from '@remote/utils/stat'
import { isMobile } from '@remote/utils/base'
import Fail from '@remote/components/Fail.vue'
import { store } from '@remote/store'
import { useDisk } from '@remote/store/hezi-file/disk'
import { addScrapeDirs } from '@remote/api/adapter/shell-mqtt'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cinemaStore = useCinemaStore()
const diskStore = useDisk()
const isPhone = isMobile()

const slides = computed(() => {
  const _slides = [
    {
      title: '首页',
      component: CinemaSlideIndex,
      stat: 'home',
    },
    {
      title: '电影',
      component: CinemaSlideMovie,
      stat: 'movie',
    },
    {
      title: '电视剧',
      component: CinemaSlideTVSeries,
      stat: 'tele',
    },
    {
      title: '其他',
      component: CinemaSlideOther,
      stat: 'other',
    },
  ]
  return _slides
})

const currentSlideIndex = ref(0)

// const headerRef = ref<ComponentPublicInstance | null>(null)

const isOffline = computed(() => {
  return !store.state.status && store.state.loading === 0
})

const isDiskException = computed(() => {
  return diskStore.data.diskException
})

const target = computed(() => {
  return store.state.curDeviceRunner?.target
})

function getScrollElement () {
  const slides = document.querySelectorAll<HTMLElement>('.cinema__content .cinema-slide__content')
  const target = slides.item(currentSlideIndex.value)
  return target
}

function onRefresh (callback) {
  if (cinemaStore.isScraping) {
    callback('fail')
    return
  }
  if (checkState()) {
    callback('fail')
    return
  }
  addScrapeDirs()
  cinemaStore.createScrapeTask('manual_btn_click')
  cinemaStore.getScrapeVersion()
  // stat({
  //   action: 'cinema_tab_click',
  //   data: { click_id: 'refresh' },
  // })

  const unsubscribe = cinemaStore.$subscribe((mutation, state) => {
    if (!state.isScraping) {
      callback('done')
      unsubscribe()
    }
  })
}

const slideIndexDataMap = ['recentList', 'movieList', 'tvList', 'otherList']
const slideIndexRefreshFuncMap = ['refreshRecentNFOList', 'refreshMovieNFOList', 'refreshTvNFOList', 'refreshOtherNFOList']

watch(currentSlideIndex, () => {
  const dataKey = slideIndexDataMap[currentSlideIndex.value]
  if (dataKey) {
    const currentSlideDataIsEmpty = cinemaStore[dataKey]?.length === 0
    console.log('currentSlideDataIsEmpty', currentSlideDataIsEmpty)
    if (currentSlideDataIsEmpty) {
      const refreshFunc = cinemaStore[slideIndexRefreshFuncMap[currentSlideIndex.value]] as Function
      if (typeof refreshFunc === 'function') refreshFunc()
    }
  }
})

watch(target, async (val) => {
  if (val) {
    Promise.all([
      cinemaStore.refreshRecentNFOList(),
      cinemaStore.refreshMovieNFOList(),
      cinemaStore.refreshTvNFOList(),
      cinemaStore.refreshOtherNFOList(),
    ])
  }
})

// onMounted(async () => {
// await baseStore.untilTargetReady()
// setTimeout(() => {
//   Promise.all([
//     cinemaStore.refreshMovieNFOList(),
//     cinemaStore.refreshTvNFOList(),
//     // cinemaStore.refreshOtherNFOList(),
//   ])
// }, 16)
// const result = await getNFODirs({ preset: false })
// let hasInit = false
// if (Array.isArray(result.dirs) && result.dirs.length > 0) {
//   hasInit = true
// } else {
//   // 盒子关闭打开设置蒙层
//   if (!store.state.isXlBox) openCinemaSourceSetting()
// }
// stat({ action: 'cinema_channel_enter', data: { if_scraper_initial: hasInit ? 1 : 0 } })
// })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cinema__content", { exception: _unref(isOffline) || _unref(isDiskException) }])
  }, [
    _createVNode(CinemaHeader, {
      slides: _unref(slides),
      currentSlideIndex: currentSlideIndex.value,
      "onUpdate:currentSlideIndex": _cache[0] || (_cache[0] = ($event: any) => ((currentSlideIndex).value = $event))
    }, null, 8, ["slides", "currentSlideIndex"]),
    _createVNode(CinemaRefreshBar),
    _createVNode(AndroidPullToRefresh, {
      disabled: !_unref(isPhone),
      "no-scrollbar": true,
      indicator: { color: '#FCD68F', backgroundColor: '#fff' },
      "scroll-key": currentSlideIndex.value,
      "get-scroll-element": getScrollElement,
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        (_unref(isOffline) || _unref(isDiskException))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(Fail)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "cinema__slides-wrapper",
              style: _normalizeStyle({
          width: `${_unref(slides).length * 100}%`,
          'transform': `translateX(-${currentSlideIndex.value * 100 / _unref(slides).length}%)`
        })
            }, [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (item, index) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                    key: index,
                    "is-showing": currentSlideIndex.value === index,
                    class: "cinema-slide__content"
                  }, null, 8, ["is-showing"]))
                }), 128))
              ], 1024))
            ], 4))
      ]),
      _: 1
    }, 8, ["disabled", "scroll-key"])
  ], 2))
}
}

})